import { Component } from '@angular/core';

@Component({
  selector: 'app-flip-card-back',
  template: `
  <div class="app-flip-card-back">
    <ng-content></ng-content>
  </div>
  `,
  styleUrls: ['./flip-card.component.scss'],
  standalone: false
})
export class FlipCardBackComponent { }
